import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { InboxModel } from './../models/inbox.model';
import { InboxService } from './../models/inbox.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'wego-inbox-view',
  template: require('../views/inbox-view.component.html'),
  styles: [`
          .box-body{
            padding: 0px 10px 10px;
          }
          .mailbox-read-message table tbody tr td
          , .mailbox-read-message table tbody tr th {
              padding: 5px;
          }
          `
  ]
})
export class InboxViewComponent implements OnInit {
  @Input('NotificationInboxHashID') hashID: string;
  private apiErrorMsg: string;
  private model: InboxModel;
  private isLoading: boolean;

  constructor(
    private authService: AuthService
    , private router: Router
    , private translate: TranslateService
    , private inboxService: InboxService) {
  }

  ngOnChanges(change: any) {
    if (change.hashID.currentValue) {
      this.ShowNotification();
    }
  }

  ngOnInit() {

  }

  private ShowNotification() {
    this.isLoading = true;
    this.inboxService.ShowNotification(this.hashID)
      .subscribe(
      res => {
        this.model = res.data;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/inbox/components/inbox-view.component.ts